export const DEFAULT_PROMO_TERMS = [
  "n%",
  "sale",
  "off",
];

export const BRANDS = "brands";
export const PROMOS = "promos";
export const KEYWORDS = "keywords";